<template>
<div>
    <v-card>
        <v-container fluid grid-list-sm>
            <v-layout row wrap>
                <v-flex offset-xs1 xs10 offset-md1 md10 offset-sm2 sm8>
                    <v-img :src="url_img"></v-img>
                    <template v-if="error_ping">
                        <!-- here will be the view for api error -->
                        <v-flex class="headline text-xs-center">{{ $t('message.error_msg') }}</v-flex>
                        <v-flex class="light-blue--text text--darken-3 text-xs-center my-4">
                            {{$t('message.invalid_api')}}
                        </v-flex>
                        <v-btn block outline color="light-blue darken-3" @click="cancel">{{ $t('message.close') }}</v-btn>
                    </template>
                    <template v-else>
                        <v-flex class="headline text-xs-center">{{ $t('message.error_msg') }}</v-flex>
                        <v-flex class="light-blue--text text--darken-3 text-xs-center my-4">
                                {{ error_message }}
                        </v-flex>
                        <!-- buttons -->
                        <!-- <v-flex  class="blue-grey--text text--lighten-1 my-4 text-xs-center"> {{ $t('message.contact_bank') }} </v-flex > -->

                        <v-btn block :disabled="pending" :loading="pending" @click="tryAgain" color="success">{{ $t('message.try_again') }}</v-btn>

                        <v-flex class="blue-grey--text text--lighten-1 my-4 text-xs-center"> {{ $t('message.choose') }} </v-flex>

                        <v-btn block color="light-blue darken-3" class="white--text my-4" @click="useAnother">{{ $t('message.use_another_card') }}</v-btn>

                        <v-btn block outline color="light-blue darken-3" @click="cancel">{{ $t('message.cancel') }}</v-btn>
                    </template>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</div>
</template>

<script>
// import { EventBus } from './EventBus.js';

export default {
    name: 'Error',
    props: {
        error_message: { type: String, default: '' },
        pending: { type: Boolean, default: false },
        error_ping: { type: Boolean, default: false },
        url_img: {type: String, default: ''},
    },
    data() {
        return {
            message: ''
        }
    },
    methods: {
        tryAgain() {
            this.$emit('tryAgain');
        },
        useAnother() {
            this.$emit('useAnother');
        },
        cancel() {
            this.$emit('cancel');
        },
    }
}
</script>
<style>
/* TODO: change px for rem */
.subheading{
    font-size:12px !important;
}
</style>
